// Financial-period helpers. A "financial period" is 1-12; period 1 maps to the
// configured financial-year start month (Settings > Config Items).

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const PERIODS = Array.from({ length: 12 }, (_, i) => i + 1);

// Calendar-month label for a financial period, given the FY start month (1-12).
export const periodLabel = (period, fyStartMonth = 1) =>
  MONTHS[((Number(fyStartMonth) - 1) + (Number(period) - 1)) % 12];

export default { MONTHS, PERIODS, periodLabel };
